import { Component, Input, OnInit } from '@angular/core';
import { UserService } from '../services/user.service';
import { Observable } from 'rxjs/Observable';
import { User } from '../model/user.class';
import { Publisher } from '../model/publisher.class';

@Component({
    selector: 'app-publisher-user',
    templateUrl: './publisher.user.component.html'
})
export class PublisherUserComponent implements OnInit {

    @Input() publisherId;

    users: User[];
     columns: Array<any> = [
        {
            title: 'Vorname',
            name: 'firstName',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Vorname filtern' }
        },
        {
            title: 'Nachname',
            name: 'lastName',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Nachname filtern' }
        },
        {
            title: 'Mailadresse',
            name: 'mail',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Mailadresse filtern' }
        },
        {
            title: 'Benutzertyp',
            name: 'userType',
            sort: '',
            filtering: { filterString: '', placeholder: 'Nach Benutzertyp filtern' }
        }
    ];

    constructor(public userService: UserService) { }

    ngOnInit() {
        this.userService.getBy('user', this.publisherId, 'publisher').subscribe(data => this.users = data as User[]);
    }
}



// WEBPACK FOOTER //
// ./src/app/publisherUser/publisher.user.component.ts